import { values } from 'lodash/fp';

import { ProductOption } from '../../../../../src/client/types/__codegen__/sanity/graphql';
import ADD_ONS from '../../../../../src/client/pages/add-ons/constants';
import CashBoostUsefulDocumentsPage from '../../../../../src/client/pages/add-ons/cash-boost/useful-documents';
import constants from '../../../../../src/client/ahm-constants';
import getAddonProps from '../../../../utils/get-add-on-props';
import getShouldSkipClientSideRequest from '../../../../../src/client/utils/get-should-skip-client-side-request';
import getStaticPathsForAddOns from '../../utils/get-static-paths-for-add-ons';
import RedirectAdapter from '../../../../../src/client/utils/redirect-adapter';
import useGetAddOnData from '../../../../../src/client/pages/add-ons/hooks/use-get-add-on-data';

type UsefulDocumentsPageProps = {
  content: ProductOption;
  slug: string;
};

const UsefulDocumentsPage = ({ content, slug }: UsefulDocumentsPageProps) => {
  const shouldSkip = getShouldSkipClientSideRequest();

  const {
    data: clientSideCmsData,
    hasError,
    isLoading,
  } = useGetAddOnData({
    addOn: slug,
    shouldSkip,
  });

  if (hasError) {
    return <RedirectAdapter to={constants.URLS.SALES.ERROR_500} />;
  }

  return <CashBoostUsefulDocumentsPage content={shouldSkip && !isLoading ? content : clientSideCmsData} />;
};

export const getStaticPaths = () => getStaticPathsForAddOns(values(ADD_ONS));

export const getStaticProps = getAddonProps;

export default UsefulDocumentsPage;
